<template>
  <div>
    <template class="column is-full" v-if="!isIndicatorNotSelected">
      <div class="columns is-multiline">
        <div class="column is-full m-b-xs m-t-md">
          <span class="has-text-weight-bold m-r-sm">
            Источник данных
          </span>
          <b-tag closable size="is-medium" aria-close-label="Очистить" @close="clearObject">
            {{ selectedObject.name }}
          </b-tag>
        </div>

        <div class="column is-full" v-if="!singleIndicator">
          <b-field label="Имя объекта" label-position="on-border">
            <b-input v-model="name"></b-input>
          </b-field>
        </div>

        <div class="column is-full" v-if="type === 'chart' && singleIndicator">
          <b-field label-position="on-border">
            <template #label>Название</template>
            <b-input expanded v-model="chart.dataSource.chart.caption"></b-input>
          </b-field>
        </div>

        <div class="column is-full" v-if="!singleIndicator">
          <div class="block">
            <b-radio
              v-model="type"
              name="name"
              native-value="value"
              size="is-small"
              :disabled="isMultiseriesDataSetted"
              v-if="availableTypes.some(el => el === 'value')"
            >
              Показатель
            </b-radio>

            <b-radio
              v-model="type"
              name="name"
              native-value="table"
              size="is-small"
              :disabled="selectedObject.indicators.length === 1"
              v-if="availableTypes.some(el => el === 'table')"
            >
              Таблица
            </b-radio>

            <b-radio
              v-model="type"
              name="name"
              native-value="chart"
              size="is-small"
              :disabled="selectedObject.indicators.length === 1"
              v-if="availableTypes.some(el => el === 'chart')"
            >
              Гистограмма
            </b-radio>
          </div>
        </div>

        <div class="column is-full" v-if="type !== 'value'">
          <div class="columns is-multiline">
            <div class="column is-narrow" v-if="type === 'chart'">
              <b-field label="Тип гистограммы" label-position="on-border">
                <b-select v-model="chart.type" size="is-small">
                  <optgroup label="С одним разрезом данных">
                    <option v-for="(option, index) in singleseriesChartFormat" :key="index" :value="option.type">{{
                      option.name
                    }}</option>
                  </optgroup>
                  <optgroup label="С множеством разрезов данных">
                    <option v-for="(option, index) in multiseriesChartFormat" :key="index" :value="option.type">{{
                      option.name
                    }}</option>
                  </optgroup>
                </b-select>
              </b-field>
            </div>

            <div class="column is-narrow" v-if="type === 'chart'">
              <b-field label="Цветовая схема" label-position="on-border">
                <b-select v-model="chart.dataSource.chart.palettecolors" size="is-small">
                  <option v-for="(scheme, index) in chartColorSchemes" :key="index" :value="scheme.colors">{{
                    scheme.name
                  }}</option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-narrow">
              <b-field grouped>
                <b-field
                  label="Ось A"
                  label-position="on-border"
                  :type="{
                    'is-danger': options.axisX === options.axisY
                  }"
                >
                  <b-select v-model="options.axisX" size="is-small">
                    <option
                      v-for="(indicator, index) in selectedObject.indicators"
                      :key="index"
                      :class="{
                        'has-text-grey': indicator.id === options.axisY
                      }"
                      :value="indicator.id"
                      >{{ indicator.name }}</option
                    >
                  </b-select>
                </b-field>

                <b-field>
                  <b-tooltip label="Поменять местами значения осей">
                    <b-button size="is-small" type="is-text" @click="swapAxises">
                      <b-icon icon="swap-horizontal"></b-icon>
                    </b-button>
                  </b-tooltip>
                </b-field>

                <b-field
                  label="Ось B"
                  label-position="on-border"
                  :type="{
                    'is-danger': options.axisX === options.axisY
                  }"
                >
                  <b-select v-model="options.axisY" size="is-small">
                    <option
                      v-for="(indicator, index) in selectedObject.indicators"
                      :key="index"
                      :class="{
                        'has-text-grey': indicator.id === options.axisX
                      }"
                      :value="indicator.id"
                      >{{ indicator.name }}</option
                    >
                  </b-select>
                </b-field>
              </b-field>
            </div>

            <div class="column is-narrow" v-if="type === 'chart'">
              <b-field grouped group-multiline>
                <b-field label="Высота" label-position="on-border">
                  <b-numberinput
                    type="is-grey"
                    size="is-small"
                    step="50"
                    min="250"
                    controls-position="compact"
                    v-model="height"
                    class="number-input"
                  ></b-numberinput>
                </b-field>

                <b-field label-position="on-border">
                  <template #label>Ширина </template>
                  <b-numberinput
                    type="is-grey"
                    size="is-small"
                    step="50"
                    min="250"
                    controls-position="compact"
                    v-model="width"
                    class="number-input"
                    :disabled="autoWidth"
                  ></b-numberinput>
                </b-field>

                <b-field>
                  <b-switch class="m-t-xs" v-model="autoWidth" size="is-small">Автоширина</b-switch>
                </b-field>
              </b-field>
            </div>

            <div class="column is-full" v-if="type === 'chart'">
              <b-field grouped group-multiline>
                <b-field>
                  <b-switch v-model="chart.dataSource.chart.setAdaptiveYMin" size="is-small">
                    Адаптивная шкала
                    <b-tooltip label="Нижняя граница шкалы принимает минимальные значения">
                      <b-icon icon="information-outline" size="is-small"></b-icon>
                    </b-tooltip>
                  </b-switch>
                </b-field>

                <b-field>
                  <b-switch v-model="chart.dataSource.chart.showValues" size="is-small">
                    Показать значения
                  </b-switch>
                </b-field>

                <b-field>
                  <b-switch v-model="chart.dataSource.chart.showLabels" size="is-small">
                    Показать подписи
                  </b-switch>
                </b-field>

                <b-field>
                  <b-switch v-model="chart.dataSource.chart.showPercentValues" size="is-small">
                    Значения в процентах %
                    <b-tooltip label="Для диаграмм с накоплением">
                      <b-icon icon="information-outline" size="is-small"></b-icon>
                    </b-tooltip>
                  </b-switch>
                </b-field>
              </b-field>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="type === 'chart' && validate.isDataValid">
          <div class="chart-box">
            <fusioncharts
              ref="dataChart"
              :type="chart.type"
              :width="chart.width"
              :height="chart.height"
              :dataFormat="chart.dataFormat"
              :dataSource="chart.dataSource"
            >
            </fusioncharts>
            <b-loading :is-full-page="false" :active.sync="chartLoading"></b-loading>
          </div>
        </div>

        <div class="column is-full" v-if="selectedObject.indicators">
          <div class="columns is-multiline">
            <div class="column" v-for="(indicator, index) in selectedObject.indicators" :key="index">
              <TagSingleInput
                v-if="type === 'value'"
                :label="indicator.name"
                :field="'name'"
                :index="index"
                :data="filteredValues[index]"
                v-model="selectedValues[index]"
              >
              </TagSingleInput>
              <TagMultipleInput
                v-else
                :label="indicator.name"
                :field="'name'"
                :index="index"
                :data="filteredValues[index]"
                v-model="selectedValues[index]"
              >
              </TagMultipleInput>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template class="column is-full" v-else>
      <b-tabs v-model="activeTab">
        <b-tab-item label="По категориям" icon="file-tree">
          <b-menu v-if="tree">
            <b-menu-list :label="topLevel.name" v-for="topLevel of findTopLevel(tree)" :key="topLevel.id">
              <TreeItemDrillDown
                :tree="tree"
                :topLevelId="topLevel.id"
                @selectItem="setSelectedData"
              ></TreeItemDrillDown>
            </b-menu-list>
          </b-menu>
        </b-tab-item>

        <b-tab-item label="Поиск" icon="magnify">
          <DataTable
            :loading="loading"
            :listData="listData"
            :listHeader="listHeader"
            :total="listTotal"
            :perPage="7"
            :selectable="true"
            @loadData="getData"
            @loadHeader="getHeader"
            @selectRow="setSelectedData"
          ></DataTable>
        </b-tab-item>

        <b-tab-item label="Избранное" disabled>1</b-tab-item>
      </b-tabs>
    </template>

    <b-modal :active.sync="isRenameDialogShow" has-modal-card>
      <div class="modal-card">
        <section class="modal-card-body">
          <div class="title is-5">Укажите новое имя объекта</div>
          <div class="content has-text-7">
            <b-field label="Новое имя объекта" label-position="on-border">
              <b-input v-model="newName"></b-input>
            </b-field>
          </div>
          <div class="buttons">
            <b-button @click="isRenameDialogShow = false">Отмена</b-button>
            <b-button @click="tryToDuplicateObject" type="is-primary">Сохранить</b-button>
          </div>
        </section>
      </div>
    </b-modal>

    <slot name="actions" :isEditState="isEditState" :isIndicatorNotSelected="isIndicatorNotSelected"></slot>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { randomId } from '@/plugins/helpers';
import { debounce } from 'lodash';
import api from '@/api/api';

function selectInitialConstructorValues() {
  const valuesLength = 5;
  const series = [];

  function getRandomElement(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  return function(index, array) {
    series[index] = [];
    const levels = [...new Set(array.map(el => el.level))];
    const initialData = array.filter(el => el.level === levels[levels.length - 1]);

    function buildInitialArray() {
      const randomElement = getRandomElement(initialData);

      if (series[index].some(el => el.id === randomElement.id)) {
        buildInitialArray();
      } else {
        series[index].push(randomElement);
      }
    }

    let numberOfValues;
    if (valuesLength > initialData.length) {
      numberOfValues = initialData.length;
    } else {
      numberOfValues = valuesLength;
    }

    for (let i = 0; i < numberOfValues; i++) {
      buildInitialArray();
    }

    return series[index];
  };
}

let setInitialClosure = selectInitialConstructorValues();

export default {
  components: {
    DataTable: () => import(/* webpackChunkName: "DataTable" */ '@/components/shared/DataTable'),
    TagMultipleInput: () => import(/* webpackChunkName: "TagMultipleInput" */ '@/components/shared/TagMultipleInput'),
    TagSingleInput: () => import(/* webpackChunkName: "TagSingleInput" */ '@/components/shared/TagSingleInput'),
    TreeItemDrillDown: () =>
      import(/* webpackChunkName: "TreeItemDrillDown" */ '@/components/shared/TreeItemDrillDown.vue')
  },
  props: {
    actionType: {
      type: String,
      default: ''
    },
    actionEmit: {
      type: Number,
      default: 0
    },
    codes: {
      type: Array,
      required: true
    },
    codeHandle: {
      type: Object
    },
    variables: {
      type: Array,
      required: true
    },
    availableTypes: {
      type: Array,
      default: () => ['value', 'table', 'chart']
    },
    singleIndicator: {
      type: Boolean,
      default: false
    },
    defaultType: {
      type: String,
      default: 'value'
    }
  },
  data() {
    return {
      activeTab: 0,
      tree: null,
      loading: true,
      chartLoading: true,
      internalId: randomId(),
      title: 'Выберите индикатор',
      selectedObject: {},
      selectedValues: [],
      filteredValues: [],
      type: this.defaultType,
      name: '',
      newName: '',
      cleared: false,
      isChartCaptionEnabled: false,
      isRenameDialogShow: false,
      autoWidth: true,
      options: {
        axisX: '',
        axisY: ''
      },
      chartColorSchemes: [
        {
          name: 'Цветовая схема 1',
          colors: process.env.VUE_APP_COLOR_SCHEME
        },
        {
          name: 'Цветовая схема 2',
          colors: 'DAF7A6,FFC300,FF5733,C70039,900C3F,581845'
        },
        {
          name: 'Цветовая схема 3',
          colors: 'ED5565,FFCE54,48CFAD,5D9CEC,EC87C0,CCD1D9,A0D468,AC92EC,656D78'
        }
      ],
      chart: {
        type: 'mscolumn2d',
        width: '100%',
        height: '450',
        dataFormat: 'json',
        dataSource: {
          chart: {
            exportEnabled: true,
            exportFormats:
              'PNG=Скачать в формате PNG|JPG=Скачать в формате JPG|SVG=Скачать в формате SVG|PDF=Скачать в формате PDF',
            palettecolors: process.env.VUE_APP_COLOR_SCHEME,
            baseFont: 'Segoe UI, Roboto',
            baseFontSize: 11,
            legendItemFont: 'Segoe UI, Roboto',
            legendItemFontSize: 11,
            outCnvBaseFont: 'Segoe UI, Roboto',
            outCnvBaseFontSize: 11,
            xAxisNameFont: 'Segoe UI, Roboto',
            xAxisNameFontSize: 11,
            yAxisNameFont: 'Segoe UI, Roboto',
            yAxisNameFontSize: 11,
            labelFontSize: 11,
            labelAlpha: 60,
            theme: 'fusion',
            captionFont: 'Segoe UI, Roboto',
            subCaptionFont: 'Segoe UI, Roboto',
            captionFontBold: 0,
            captionFontSize: 18,
            captionAlignment: 'left',
            thousandSeparator: ' ',
            decimalSeparator: ',',
            plotSpacePercent: 20,
            placeValuesInside: 1,
            valueFontAlpha: 60,
            formatNumberScale: 0,
            animation: 0,
            drawcrossline: 1,
            adjustDiv: 1,
            drawAnchors: 1,
            loadMessage: 'Загрузка',
            caption: '',
            subcaption: '',
            showValues: true,
            showLabels: true,
            setAdaptiveYMin: false,
            showPercentValues: false
          },
          categories: null,
          dataset: null,
          data: null
        }
      },

      availableChartTypes: [
        { name: 'Линейчатая с группировкой', type: 'msbar2d', format: 'multi' },
        {
          name: 'Линейчатая с группировкой (3D)',
          type: 'msbar3d',
          format: 'multi'
        },
        {
          name: 'Гистограмма с группировкой',
          type: 'mscolumn2d',
          format: 'multi'
        },
        {
          name: 'Гистограмма с группировкой (3D)',
          type: 'mscolumn3d',
          format: 'multi'
        },
        { name: 'Линейный график', type: 'msspline', format: 'multi' },
        { name: 'С областями', type: 'MSArea', format: 'multi' },
        {
          name: 'Радар',
          type: 'radar',
          format: 'multi'
        },
        {
          name: 'Линейчатая с накоплением',
          type: 'stackedbar2d',
          format: 'multi'
        },
        {
          name: 'Линейчатая с накоплением (3D)',
          type: 'stackedbar3d',
          format: 'multi'
        },
        {
          name: 'Гистограмма с накоплением',
          type: 'stackedcolumn2d',
          format: 'multi'
        },
        {
          name: 'Гистограмма с накоплением (3D)',
          type: 'stackedcolumn3d',
          format: 'multi'
        },
        { name: 'Кольцевая', type: 'doughnut2d', format: 'single' },
        { name: 'Кольцевая (3D)', type: 'doughnut3d', format: 'single' },
        { name: 'Круговая', type: 'pie2d', format: 'single' },
        { name: 'Круговая (3D)', type: 'pie3d', format: 'single' }
      ],

      customOption: {
        name: 'Переменная',
        type: 'custom'
      },

      validate: {
        isNameValid: false,
        isDataValid: false,
        type: 'is-danger',
        message: 'Укажите источник данных'
      }
    };
  },

  async mounted() {
    api
      .getCategories()
      .then(res => {
        this.tree = res.data;
      })
      .catch(err => console.log(err));

    if (this.isEditState) {
      const { indicatorId } = this.codeHandle.data;
      const initailData = {
        id: indicatorId
      };

      await this.setSelectedData(initailData);
    }
  },

  methods: {
    ...mapActions('tables', {
      getTablesList: 'getTablesList',
      getTablesHeader: 'getTablesHeader'
    }),

    findTopLevel(tree) {
      return tree.filter(el => el.type === 'category' && !tree.some(category => category.id === el.parent_id));
    },

    getHeader() {
      this.getTablesHeader();
    },

    async getData(params) {
      this.loading = true;
      await this.getTablesList(params);

      if (!this.isEditState) {
        this.loading = false;
      }
    },

    async setSelectedData(data) {
      await api
        .getTableDetails(data.id)
        .then(res => {
          this.selectedObject = res.data;

          // create initial arrays
          for (let i = 0; i < res.data.indicators.length; i++) {
            const indicator = res.data.indicators[i];

            const seriesVariables = () => {
              const variables = this.variables.filter(variable => variable.data.indicatorId == indicator.id);

              const getValueName = id => {
                const valueInSerie = indicator.data.find(value => value.id == id);
                return valueInSerie.name;
              };

              const adaptVariables = variables.map(variable => {
                const { parentId, selectedId, selectedLevel, name, ...rest } = variable;

                return {
                  id: selectedId,
                  level: selectedLevel,
                  name: name,
                  parent_item: parentId,
                  ...rest
                };
              });

              return adaptVariables;
            };

            this.filteredValues[i] = [...(seriesVariables() || []), ...indicator.data];

            if (this.isEditState) {
              this.name = this.codeHandle.id.substr(1);
              this.type = this.codeHandle.type.typeName;
              this.internalId = this.codeHandle.internalId;

              if (this.type !== 'value') {
                this.options.axisX = this.codeHandle.type.options.axisX;
                this.options.axisY = this.codeHandle.type.options.axisY;
              }

              if (this.type === 'chart') {
                this.autoWidth = this.codeHandle.type.options.autoWidth;
                this.chart.type = this.codeHandle.type.options.chart.type;
                this.chart.height = this.codeHandle.type.options.chart.height;
                this.chart.width = this.codeHandle.type.options.chart.width;
                this.chart.dataSource.chart.setAdaptiveYMin = this.codeHandle.type.options.chart.dataSource.chart.setAdaptiveYMin;
                this.chart.dataSource.chart.showValues = this.codeHandle.type.options.chart.dataSource.chart.showValues;
                this.chart.dataSource.chart.showLabels = this.codeHandle.type.options.chart.dataSource.chart.showLabels;
                this.chart.dataSource.chart.showPercentValues = this.codeHandle.type.options.chart.dataSource.chart.showPercentValues;
                this.chart.dataSource.chart.palettecolors = this.codeHandle.type.options.chart.dataSource.chart.palettecolors;
                this.chart.dataSource.chart.caption = this.codeHandle.type.options.chart.dataSource.chart.caption;
                this.chart.height = this.codeHandle.type.options.chart.height;
              }

              this.selectedValues = this.codeHandle.data.series.map(el => {
                return el.values;
              });
            } else {
              if (this.singleIndicator) {
                this.chart.dataSource.chart.caption = this.selectedObject.name;
                this.selectedValues[i] = setInitialClosure(i, this.selectedObject.indicators[i].data);
              } else {
                this.selectedValues[i] = [];
              }

              this.options.axisX = this.selectedObject.indicators[this.selectedObject.indicators.length - 1].id; // FIXME захардкодено
              this.options.axisY = this.selectedObject.indicators[this.selectedObject.indicators.length - 2].id; // FIXME захардкодено
              this.setName();
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    setName() {
      let counter = 1;
      this.name = `Показатель [${counter}]`;

      while (!this.validateName(this.name)) {
        counter++;
        this.name = `Показатель [${counter}]`;
      }
    },

    swapAxises() {
      const oldAxisX = this.options.axisX;
      const oldAxisY = this.options.axisY;

      this.options.axisX = oldAxisY;
      this.options.axisY = oldAxisX;
    },

    clearObject() {
      this.selectedObject = {};
      this.selectedValues = [];
      this.filteredValues = [];
      this.type = this.defaultType;
      this.autoWidth = true;
      this.options.axisX = '';
      this.options.axisY = '';
      this.chart.type = 'mscolumn2d';
      this.chart.dataSource.chart.setAdaptiveYMin = false;
      this.cleared = true;
      this.validate = {
        isDataValid: false,
        isNameValid: false,
        type: 'is-danger',
        message: 'Укажите источник данных'
      };
    },

    validateData() {
      if (!this.singleIndicator) {
        if (this.name === '' || !this.validateName(this.name)) {
          return false;
        }
      }

      if (this.type !== 'value') {
        if (this.options.axisX === this.options.axisY || this.options.axisX === '' || this.options.axisY === '') {
          this.validate.message = 'Данные осей должны быть заполнены и не должны совпадать';
          this.validate.isDataValid = false;

          return false;
        }
      }

      for (let i = 0; i < this.selectedValues.length; i++) {
        if (this.selectedValues[i].length === 0) {
          this.validate.message = 'Требуется корректно заполнить все поля';
          this.validate.isDataValid = false;
          return false;
        }
      }

      this.validate.isDataValid = true;
      return true;
    },

    validateName(name) {
      if (name === '') {
        this.validate.isNameValid = false;
        this.validate.message = 'Имя объекта должно быть заполнено и уникально';
        return false;
      }

      let names = [...this.codes.map(code => code.name), ...this.variables.map(variable => variable.name)];

      if (this.isEditState && this.actionType !== 'duplicate') {
        names = names.filter(name => name !== this.codeHandle.id.substr(1));
      }

      if (names.some(el => el === name)) {
        this.validate.isNameValid = false;
        this.validate.message = 'Данное имя уже используется';
        return false;
      }

      this.validate.isNameValid = true;
      return true;
    },

    buildDataObject() {
      const buildSeries = () => {
        let series = [];

        for (let i = 0; i < this.selectedValues.length; i++) {
          const element = this.selectedValues[i];

          const serieData = element.map(el => {
            const type = () => {
              if (el.internalId) {
                return 'variable';
              } else {
                return 'constant';
              }
            };

            return {
              id: el.id,
              name: el.name,
              type: type(),
              internalId: el.internalId || null
            };
          });

          const serie = {
            id: this.selectedObject.indicators[i].id,
            values: serieData
          };

          series.push(serie);
        }

        return series;
      };

      const buildOptions = () => {
        if (this.type === 'value') {
          return;
        } else if (this.type === 'table') {
          return {
            axisX: this.options.axisX,
            axisY: this.options.axisY
          };
        } else if (this.type === 'chart') {
          return {
            autoWidth: this.autoWidth,
            axisX: this.options.axisX,
            axisY: this.options.axisY,
            chart: this.chart
          };
        }
      };

      return {
        name: this.name,
        internalId: this.internalId,
        type: {
          typeName: this.type,
          options: buildOptions()
        },
        data: {
          indicatorId: this.selectedObject.id,
          series: buildSeries()
        }
      };
    },

    buildChartDebounce: debounce(function() {
      this.buildChart();
    }, 1000),

    tryToCreateObject() {
      if (!this.validateData()) {
        this.toast({
          message: this.validate.message,
          type: this.validate.type
        });

        return;
      }

      if (this.actionType === 'create') {
        this.$emit('addShortCode', this.buildDataObject());
      } else if (this.actionType === 'duplicate') {
        this.internalId = randomId();
        this.$emit('addShortCode', this.buildDataObject());
      } else if (this.actionType === 'edit') {
        this.$emit('editShortCode', this.buildDataObject());
      }
    },

    tryToDuplicateObject() {
      if (this.validateName(this.newName)) {
        this.name = this.newName;
        this.isRenameDialogShow = false;
        this.tryToCreateObject();
      } else {
        this.toast({
          message: this.validate.message,
          type: this.validate.type
        });
      }
    },

    buildChart() {
      this.chartLoading = true;

      const data = {
        data: {
          codes: [this.constructedObject]
        }
      };

      api
        .getChartData(data)
        .then(res => {
          const { categories, dataset, data } = res.data.dataSource;

          this.chart.dataSource.categories = categories || null;
          this.chart.dataSource.dataset = dataset || null;
          this.chart.dataSource.data = data || null;
        })
        .then(() => {
          this.chartLoading = false;
        });
    }
  },

  computed: {
    ...mapState({
      listData: state => state.tables.listData,
      listTotal: state => state.tables.listTotal,
      listHeader: state => state.tables.listHeader
    }),

    isIndicatorNotSelected() {
      return this.checkObjectForEmpty(this.selectedObject);
    },

    isEditState() {
      return !this.checkObjectForEmpty(this.codeHandle) && !this.cleared;
    },

    isMultiseriesDataSetted() {
      return this.selectedValues.some(el => el.length > 1);
    },

    multiseriesChartFormat() {
      return this.availableChartTypes.filter(el => el.format === 'multi');
    },

    singleseriesChartFormat() {
      return this.availableChartTypes.filter(el => el.format === 'single');
    },

    constructedObject() {
      return this.buildDataObject();
    },

    chartType() {
      return this.chart.type;
    },

    height: {
      get() {
        return +this.chart.height;
      },
      set(value) {
        this.chart.height = `${value}`;
      }
    },

    width: {
      get() {
        return +this.chart.width || null;
      },
      set(value) {
        this.chart.width = `${value}`;
      }
    }
  },
  watch: {
    name() {
      this.validateName(this.name);
    },

    autoWidth(newValue, oldValue) {
      if (newValue !== oldValue && this.chart.width === '100%') {
        this.width = 500;
      } else if (newValue) {
        this.width = '100%';
      }
    },

    chartType(newValue, oldValue) {
      this.validateData();

      if (this.validate.isDataValid) {
        this.buildChartDebounce();

        if (!this.singleIndicator) {
          return;
        }

        if (this.isEditState) {
          this.$emit('editShortCode', newValue);
        } else {
          this.$emit('addShortCode', newValue);
        }
      }
    },

    constructedObject(newValue) {
      this.validateData();

      if (this.validate.isDataValid && this.type === 'chart') {
        this.buildChartDebounce();

        if (!this.singleIndicator) {
          return;
        }

        if (this.isEditState) {
          this.$emit('editShortCode', newValue);
        } else {
          this.$emit('addShortCode', newValue);
        }
      }
    },

    actionEmit() {
      if (this.actionType === 'duplicate') {
        this.newName = this.name + ' Копия';
        this.isRenameDialogShow = true;
      } else {
        this.tryToCreateObject();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-box {
  position: relative;
}
.number-input {
  width: 8rem;
}
</style>
